import { render, staticRenderFns } from "./MemberCreate.vue?vue&type=template&id=6c65ff6e"
import script from "./MemberCreate.vue?vue&type=script&lang=js"
export * from "./MemberCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports